// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2qJLk","unreadBadge":"styles_unreadBadge__1Qb6A","modalContent":"styles_modalContent__3hngR","modal":"styles_modal__3wJAC"};